export const generateCustomFormItemName = (label: string): string =>
	label
		.toLowerCase() // make everything lowercase
		.replace(/[-\W]+/g, '-') // convert patterns of multiple dashes or non-word characters -> a single dash
		.replace(/^-|-$/g, ''); // strip any dash from the front or end of the slug

export default generateCustomFormItemName;
